import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
    Box,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";
  import React, { useState, useEffect, useMemo } from "react";
  import { useDispatch } from "react-redux";
  import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
  import ArrowRightIcon from "@mui/icons-material/ArrowRight";
  import _ from 'lodash'
  import { getActionLogs } from "../../../../../store/slices/reviews";
import LogDrawerCard from "../../../navbar/LogdarowerCard";
  
  const logsPerPage = 1;
  const ReviewActonLog = ({ open, handleClose,memoizedLogsData,companyId, reviewId,RequestId,title  }) => {
  
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);

   
    
    useEffect(() => {
      if (reviewId && RequestId && companyId) {
        dispatch(getActionLogs(companyId, reviewId, RequestId));  // Call the API when the parent triggers it
      }
    }, []); 
  
    useEffect(() => {
      setCurrentPage(1); // Reset page when data changes
    }, [memoizedLogsData]);
  
    const totalPages = useMemo(()=>Math.ceil(_.size(memoizedLogsData)/ logsPerPage),[memoizedLogsData]);
    const currentLogs =useMemo(()=>_.slice(memoizedLogsData,
      (currentPage - 1) * logsPerPage,
      currentPage * logsPerPage
    ),[memoizedLogsData,currentPage]); 
  
    return (
        <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
         unmountonexit={"true"}
         sx={{ marginTop: "50px" }}
         fullWidth
      >
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography variant="h6">{title}</Typography>
              <Typography>({reviewId})</Typography>
            </Stack>
            <IconButton
              onClick={handleClose}
              sx={{ position: "absolute", top: "13px", right: "15px" }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
  
        <DialogContent dividers>
          {_.size(memoizedLogsData) > 1 && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              mb={-3.5} // This will slightly adjust the bottom margin, similar to your '-30px'
            >
              <Box />
  
              {/* Right-side pagination controls */}
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  data-testid="ArrowLeftIcon"
                >
                  <ArrowLeftIcon />
                </IconButton>
  
                <Typography variant="h6">{`${currentPage} of ${totalPages}`}</Typography>
  
                <IconButton
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  data-testid="ArrowRightIcon"
                >
                  <ArrowRightIcon />
                </IconButton>
              </Stack>
            </Box>
          )}
          <Stack spacing={1}>
            {currentLogs.map((log, index) => (
              <LogDrawerCard
                key={index}
                usage={log}
                height={"calc(100vh - 425px)"}
              />
            ))}
          </Stack>
        </DialogContent>
  
        <DialogActions
          sx={{ justifyContent: "flex-start", px: 3, py: 1 }}
          dividers
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              pt: 0,
              alignItems: "center",
              width: "500px",
            }}
          >
            <Button color="primary" variant="contained" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ReviewActonLog;
  